import * as Sentry from '@sentry/browser';

import { ConfigHelper } from '@/utils/env';

const {sentryDSN, sentryEnvironment} = ConfigHelper;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
(window as any).Sentry = Sentry;

Sentry.init({
  debug: true,
  dsn: sentryDSN,
  enabled: true,
  environment: sentryEnvironment,
});
